import { render } from "./DynamicPanel.vue?vue&type=template&id=62040e5d&ts=true"
import script from "./DynamicPanel.vue?vue&type=script&lang=ts"
export * from "./DynamicPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62040e5d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62040e5d', __exports__)) {
    api.reload('62040e5d', __exports__)
  }
  
  module.hot.accept("./DynamicPanel.vue?vue&type=template&id=62040e5d&ts=true", () => {
    api.rerender('62040e5d', render)
  })

}


export default __exports__